import React, { createContext, useContext, useMemo, useState } from "react";

const NEW_UI_STORAGE_KEY = "pocketbalance.new-ui-enabled";

type NewUiContextValue = {
  isNewUiEnabled: boolean;
  setNewUiEnabled: (enabled: boolean) => void;
};

const NewUiContext = createContext<NewUiContextValue | undefined>(undefined);

function getInitialValue(): boolean {
  if (typeof window === "undefined") {
    return false;
  }

  return window.localStorage.getItem(NEW_UI_STORAGE_KEY) === "true";
}

export function NewUiProvider({ children }: { children: React.ReactNode }) {
  const [isNewUiEnabled, setIsNewUiEnabled] = useState<boolean>(getInitialValue);

  const setNewUiEnabled = (enabled: boolean) => {
    setIsNewUiEnabled(enabled);

    if (typeof window !== "undefined") {
      window.localStorage.setItem(NEW_UI_STORAGE_KEY, String(enabled));
    }
  };

  const value = useMemo(
    () => ({ isNewUiEnabled, setNewUiEnabled }),
    [isNewUiEnabled]
  );

  return <NewUiContext.Provider value={value}>{children}</NewUiContext.Provider>;
}

export function useNewUi() {
  const context = useContext(NewUiContext);

  if (!context) {
    throw new Error("useNewUi must be used within a NewUiProvider");
  }

  return context;
}
